import { Ruler, Circle as CircleIcon, Triangle, Minus, X, Skull, Slash, DoorOpen, Zap, Sparkles } from "lucide-react";
import { InfoTip } from "../InfoTip";

const TOOLS = [
  { id: "ruler", label: "Measure", icon: Ruler },
  { id: "circle", label: "Burst", icon: CircleIcon },
  { id: "cone", label: "Cone", icon: Triangle },
  { id: "line", label: "Line", icon: Minus },
];
const GM_TOOLS = [
  { id: "obstacle", label: "Obstacle", icon: Skull },
  { id: "trigger-line", label: "Trigger Line", icon: Zap },
  { id: "wall", label: "Wall (Line of Sight)", icon: Slash },
  { id: "door", label: "Door", icon: DoorOpen },
  { id: "portal", label: "Portal", icon: Sparkles },
];

// Floating tool selector (Ruler/Burst/Cone/Line + GM-only Obstacle/Trigger Line/Wall/Door/Portal)
// docked above the mobile bottom nav / desktop side panel. Extracted verbatim from MapCanvas.jsx
// (Phase 42 refactor).
export function MapToolbar({ isGm, activeTool, switchTool, clearTool }) {
  return (
    <div className="absolute bottom-36 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:bottom-20 md:right-[420px] z-20 flex gap-1.5 bg-black/60 backdrop-blur-2xl border border-white/10 rounded-full p-1.5">
      {[...TOOLS, ...(isGm ? GM_TOOLS : [])].map((t) => (
        <button
          key={t.id}
          data-testid={`tool-${t.id}`}
          onClick={() => switchTool(t.id)}
          title={t.label}
          className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-200 ${
            activeTool === t.id ? "bg-[#D90429] text-white" : "text-[#f1e0c5]/50 hover:text-[#D4AF37]"
          }`}
        >
          <t.icon className="w-4 h-4" />
        </button>
      ))}
      {activeTool && (
        <button onClick={clearTool} className="w-9 h-9 rounded-full flex items-center justify-center text-[#f1e0c5]/40">
          <X className="w-4 h-4" />
        </button>
      )}
      <InfoTip topic="map_tools" className="ml-0.5" />
    </div>
  );
}
